<script lang='ts' setup>
const appName = useRuntimeConfig().public.appName;
</script>

<template>
	<footer class="w-full h-(--ui-header-height) border-t-1 bg-accented fixed bottom-0 z-50">
		<div class="h-full flex justify-center items-center text-center px-2 space-x-3 text-xs lg:text-sm">
			<div class="flex items-center space-x-1">
				<UIcon name="i-lucide-copyright" />
				<span>{{ new Date().getFullYear() }} {{ appName }}</span>
			</div>
			<span class="hidden md:inline text-accented">•</span>
			<ULink to="/tos">Terms of Service</ULink>
			<span class="hidden md:inline text-accented">•</span>
			<ULink to="/privacy">Privacy Policy</ULink>
			<span class="hidden md:inline text-accented">•</span>
			<ULink to="/contact">Contact</ULink>

		</div>
	</footer>
</template>
